import React from 'react'
import SEO from '../components/SEO'


const PrivacyPage = () => {
  return (
    <>
        <SEO 
            title="WeFlare Privacy Policy" 
            description="WeFlare is committed to protecting your privacy. Learn how we collect, use, and safeguard your personal information." 
            keywords="WeFlare privacy policy, data privacy, personal information protection, user privacy Kenya"
            url="https://weflare.org/privacy"
        />
        <div className="container mb-3 mt-1 privacy-policy">
            <h1 className="headline2 text-primary">Our Privacy Policy</h1>
            <h2 className="headline4 text-primary">Introduction</h2>
            <p className='mt-2 lead'>
            Welcome to WeFlare. Here, we are committed to protecting the privacy of the personal information you provide to us. This Data Privacy Statement explains how we collect, use, disclose, and protect your personal information.
            </p>
            <h2 className="headline4 text-primary">What Information Do We Collect?</h2>
            <p className="mt-2 lead">
            We may collect the following types of personal information from you:
            </p>
            <ul className='lead'>
                <li>
                    <strong>Contact Information:</strong> Name, phone number, email address, postal address
                </li>
                <li>
                    <strong>Demographic Information:</strong> Age, gender (optional)
                </li>
                <li>
                    <strong>Information you provide during registration for programs or events: </strong> This may include information about your interests, skills, and experiences.
                </li>
            </ul>
            <h2 className="headline4 text-primary mt-3">How We Collect Information</h2>
            <p className="mt-2 lead">
            We collect personal information from you when you:
            </p>
            <ul>
                <li className="lead">Register for one of our programs or events</li>
                <li className="lead">Contact us with a question or request</li>
                <li className="lead">Participate in surveys or feedback forms</li>
            </ul>
            <h2 className="headline4 text-primary mt-3">How We Use Your Information</h2>
            <p className="mt-2 lead">
            We use your personal information to:
            </p>
            <ul>
                <li className="lead">Register you for programs and events</li>
                <li className="lead">Send you important information about our programs and events</li>
                <li className="lead">Respond to your inquiries and requests</li>
                <li className="lead">Improve our programs and services</li>
            </ul>
            <p className="h4">Note: We will not sell or share your personal information with third parties without your consent.</p>
            <h2 className="headline4 text-primary mt-3">Your choices</h2>
            <p className="mt-2 lead">
            You have the right to access, correct, or delete your personal information. You can also opt out of receiving communications from us. To exercise any of these rights, please contact us at <span><a
                                    href="mailto:info@weflare.org"
                                    className="text-primary"
                                >info@weflare.org</a></span>
            </p>
            <h2 className="headline4 text-primary mt-3">Data Security</h2>
            <p className="mt-2 lead">
            We take reasonable steps to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no website or internet transmission is completely secure. We cannot guarantee the security of your information.
            </p>
            <h2 className="headline4 text-primary mt-3">Children's Privacy</h2>
            <p className="mt-2 lead">
            We are committed to protecting the privacy of children. We do not knowingly collect personal information from children under the age of 13 without parental consent. If you are a parent or guardian and believe your child has provided us with personal information, please contact us so we can delete it.
            </p>
            <h2 className="headline4 text-primary mt-3">Changes to this Statement</h2>
            <p className="mt-2 lead">
            We may update this Statement from time to time. We will post any changes on our website.
            </p>
            <h2 className="mt-3 headline4 text-primary">Contact Us</h2>
            <p className="mt-2 lead">If you have any questions about this Statement, please contact us at <span><a
                                    href="mailto:info@weflare.org"
                                    className="text-decoration text-primary"
                                >info@weflare.org</a></span>.</p>
            
        </div>
    </>
  )
}

export default PrivacyPage